export const siteName = 'Legend Market'
export const chilizDropName = 'Legend & Chiliz: The Genesis'
export const legendClubName = 'Legend Club'
export const euro2024Name = 'Euro2024'
export const paris2024Name = 'Paris 2024'
export const defaultOgImageUrl = 'https://cdn.leverade.com/market/opengraph.jpg'
